import { render, staticRenderFns } from "./add-risk-score.vue?vue&type=template&id=22e0b206&"
import script from "./add-risk-score.vue?vue&type=script&lang=js&"
export * from "./add-risk-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports